import isEmpty from 'lodash/isEmpty'
import take from 'lodash/take'

const MAX_CONDITION_WORD = 8
const DEFAULT_EMPTY_WORD = '指定なし'

const buildConditionWords = (words: string[]) => {
  if (isEmpty(words)) {
    return DEFAULT_EMPTY_WORD
  }
  return words.length <= MAX_CONDITION_WORD ? words.join('、') : take(words, MAX_CONDITION_WORD).concat('...').join('、')
}

export default buildConditionWords
